import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-methodology',
  templateUrl: './methodology.component.html',
  styleUrls: ['./methodology.component.css']
})
export class MethodologyComponent implements OnInit {
  title = 'ITARIUM Technologies India Pvt. Ltd. | Project Methodology';
  constructor(private titleService: Title,private meta:Meta) { }

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.meta.addTags([
      {name: 'keywords', content: 'BMC, BMC Softwares, BMC Tools, Itarium Technologies, IT Support, Technology, Pune, IT Companies, Karvenagar' },
      {name: 'description', content: 'ITARIUM works with many organizations to provide better IT solutions as per their requirements.'},
      {name: 'robots', content: 'index, follow'}
    ]);
    window.scrollTo(0, 0)
  }

}
